import { create } from 'zustand';

export const useSessionConfigFormStore = create((set) => ({
  formData: {
    fixCustomerMappingId: null,
    custId: '',
    groupMasterId: '',
    venueId: '',
    connectionType: 'RFQ',
    senderCompId: '',
    targetCompId: '',
    targetHost: '',
    targetPort: '',
    startTime: '',
    endTime: '',
    isActive: 1,
    venueName: '',
    customerName: '',
    groupName: '',
  },
  fieldErrors: {},
  loading: false,
  error: null,

  setFormData: (data) => set((state) => ({
    formData: { ...state.formData, ...data }
  })),

  setFieldErrors: (errors) => set({ fieldErrors: errors }),

  clearFieldError: (fieldName) => set((state) => ({
    fieldErrors: {
      ...state.fieldErrors,
      [fieldName]: false
    }
  })),

  clearFieldErrors: () => set({ fieldErrors: {} }),

  setLoading: (loading) => set({ loading }),

  setError: (error) => set({ error }),

  resetFormData: () => set({
    formData: {
      fixCustomerMappingId: null,
      custId: '',
      groupMasterId: '',
      venueId: '',
      connectionType: 'RFQ',
      senderCompId: '',
      targetCompId: '',
      targetHost: '',
      targetPort: '',
      startTime: '',
      endTime: '',
      isActive: 1,
      venueName: '',
      customerName: '',
      groupName: '',
    },
    fieldErrors: {},
    loading: false,
    error: null,
  }),
}));
